import AccountLayout from "./AccountLayout";

export default AccountLayout;
